goog.provide("shadow.js.shim.module$$carbon$icons_react$es$TreeView$default");
shadow.js.shim.module$$carbon$icons_react$es$TreeView$default = shadow.js.require(375, {}).default;
